import React from "react";
import { Link } from "react-router-dom";
const NotFoundPage = () => {
  return (
    <>
      <div className="content">
        <div className="container">
          <div
            className="error-main-logo text-center"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img src="assets/img/logo-dark.svg" alt="Img" />
          </div>
          <div className="error-img text-center">
            <img src="assets/img/error-404.svg" alt="Img" />
          </div>
          <div className="maintenance-update">
            <div className="text-center mb-3">
              <h5 className="mb-1">404 Oops! Không tìm thấy trang</h5>
              <p className="text-gray-6">
                Trang này không tồn tại hoặc đã bị xóa! Chúng tôi đề nghị bạn
                quay lại trang chủ.
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <Link
                to="/"
                className="btn btn-primary d-flex align-items-center justify-content-center"
              >
                <i className="isax isax-arrow-left-2 me-2"></i>Trang chủ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
